/* eslint-disable array-callback-return */
import React, {useEffect, useState} from "react";
import "./PositionList.scss";
import axios from "axios";
import Filters from "../components/Filters/Filters";
import {createRegion} from "../components/CreateRegion/createRegion";

const PostGrid = () => {
	const [axiosData, setAxiosData] = useState(null);
	const [selectedFilter, setSelectedFilter] = useState("region-all");

	useEffect(() => {
		const fetchData = async () => {
			try {
				const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
				const sheetId = process.env.REACT_APP_SHEET_ID;
				const sheetRange = process.env.REACT_APP_SHEET_RANGE;

				console.log("apiKey:", apiKey);
				console.log("sheetId:", sheetId);
				console.log("sheetRange:", sheetRange);

				const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${encodeURIComponent(sheetRange)}?key=${apiKey}`;

				console.log("url:", url);

				const response = await axios.get(url);
				console.log("response:", response.data);

				setAxiosData(response.data);
			} catch (error) {
				console.error("Error fetching Google Sheets data:", error);
				console.error("Error response:", error?.response?.data);
			}
		};

		fetchData();
	}, []);

	const sendHeightToParent = () => {
		const iframe = window.frameElement;

		if (!iframe) return;

		const contentDocument = iframe.contentDocument;

		if (contentDocument) {
			const contentHeight = contentDocument.body.scrollHeight;

			window.parent.postMessage({type: "resizeIframe", height: contentHeight}, "*");
		}
	};

	// useEffect(() => {
	//   sendHeightToParent();
	// }, []);

	// useEffect(() => {
	//   sendHeightToParent();
	// }, [selectedFilter, axiosData]);

	const rows = axiosData?.values || [];

	const allCategories = rows.map((row) => row[4]).filter((value) => value && value.trim() !== "");

	const uniqueCategories = [...new Set(allCategories)];

	const allRegions = rows.map((row) => row[5]).filter((value) => value && value.trim() !== "");

	const allUniqueRegions = [...new Set(allRegions)];

	// useEffect(() => {
	//   if (selectedFilter === "all-regions") {
	//     window.parent.location.href = `https://jsi.gtmstaging.com/position-list/#all-regions`;
	//   } else {
	//     window.parent.location.href = `https://jsi.gtmstaging.com/position-list/#${selectedFilter}`;
	//   }
	// }, [selectedFilter]);

	return (
		<div className="position-list">
			<Filters
				regions={allUniqueRegions}
				onFilterChange={setSelectedFilter}
			/>

			{uniqueCategories.map((reg) => createRegion(reg, axiosData, selectedFilter))}
		</div>
	);
};

export default PostGrid;

// /* eslint-disable array-callback-return */
// import React, { useEffect, useState } from "react";
// import "./PositionList.scss";
// import axios from "axios";
// import Filters from "../components/Filters/Filters";
// import { createRegion } from "../components/CreateRegion/createRegion";

// const PostGrid = () => {
//   const [axiosData, setAxiosData] = useState(null);
//   const [selectedFilter, setSelectedFilter] = useState("region-all");

//   useEffect(() => {
//     const fetchData = async () => {
//       const response = await axios.get(
//         // "https://sheets.googleapis.com/v4/spreadsheets/1ViAWBU6rAfU3EIEpjaCAP6aDJEIxmZVV4YJ3vxJEFYo/values/2:999?key=AIzaSyDw5asg8ciaDk7CWwxQHBuKD3DzKSHRZfE"
//          "https://sheets.googleapis.com/v4/spreadsheets/1ViAWBU6rAfU3EIEpjaCAP6aDJEIxmZVV4YJ3vxJEFYo/values/2:999?key=AIzaSyBBfW6UZAfpPTfJVV8Ui812ommJ3fb_48U"
//       );
//       setAxiosData(response.data);
//       // setLoading(false);;
//     };

//     fetchData();
//   }, []);

//   const sendHeightToParent = () => {
//     const iframe = window.frameElement; // Get reference to the iframe element
//     const contentDocument = iframe.contentDocument; // Access the content document

//     if (contentDocument) {
//       // Use the content document's body or another element to calculate height
//       const contentHeight = contentDocument.body.scrollHeight;

//       // Send the height to the parent
//       window.parent.postMessage(
//         { type: "resizeIframe", height: contentHeight },
//         "*"
//       );
//     }
//   };

//   // useEffect(() => {
//   //   sendHeightToParent();
//   // }, []);

//   // useEffect(() => {
//   //   sendHeightToParent();
//   // }, [selectedFilter]);

//   const allCategories = axiosData?.values.map((c) => c[4]);
//   const uniqueCategories = [...new Set(allCategories)];
//   const allRegions = axiosData?.values.map((c) => c[5]);
//   const allUniqueRegions = [...new Set(allRegions)];

//   // useEffect(() => {
//   //   if (selectedFilter === "all-regions") {
//   //     window.parent.location.href = `https://jsi.gtmstaging.com/position-list/#all-regions`;
//   //   } else {
//   //     window.parent.location.href = `https://jsi.gtmstaging.com/position-list/#${selectedFilter}`;
//   //   }
//   // }, [selectedFilter]);

//   return (
//     <div className="position-list">
//       <Filters regions={allUniqueRegions} onFilterChange={setSelectedFilter} />
//       {uniqueCategories?.map((reg, index) =>
//         createRegion(reg, axiosData, selectedFilter)
//       )}
//     </div>
//   );
// };

// export default PostGrid;
